import { render, staticRenderFns } from "./DisableTOTP.vue?vue&type=template&id=e36e8248&"
import script from "./DisableTOTP.vue?vue&type=script&lang=js&"
export * from "./DisableTOTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports